import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import Button from "../../../components/FormComponents/Button";
import Input from "../../../components/FormComponents/Input";

const FilterSection = ({ filters, onFilterChange, onReset, userOptions, appOptions, logTypeOptions }) => {
  const toLocalDatetimeString = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const toUTCISOString = (localDatetime) => {
    if (!localDatetime) return undefined;
    const date = new Date(localDatetime);
    return date.toISOString();
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
        gap: "12px",
        padding: "12px 0px",
        borderRadius: "6px"
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className="builder_label">Log Type</label>

        <SingleSelectBox
          options={logTypeOptions}
          valueKey="value"
          labelKey={["label"]}
          selectedData={filters.type}
          onChange={(option) => onFilterChange("type", option?.value)}
          placeholder="All Log Types"
          isSearch={false}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className="builder_label">User</label>
        <SingleSelectBox
          options={userOptions}
          valueKey="value"
          labelKey={["label"]}
          selectedData={filters.user_id}
          onChange={(option) => onFilterChange("user_id", option?.value)}
          placeholder="Search user by email..."
          isSearch={true}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className="builder_label">App</label>
        <SingleSelectBox
          options={appOptions}
          valueKey="value"
          labelKey={["label"]}
          selectedData={filters.app_id}
          onChange={(option) => onFilterChange("app_id", option?.value)}
          placeholder="Search app..."
          isSearch={true}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className="builder_label">From Date</label>
        <Input
          inputBoxStyle={{ height: "30px" }}
          type="datetime-local"
          value={toLocalDatetimeString(filters.from_date)}
          onChange={(e) => onFilterChange("from_date", toUTCISOString(e.target.value))}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className="builder_label">To Date</label>
        <Input
          inputBoxStyle={{ height: "30px" }}
          type="datetime-local"
          value={toLocalDatetimeString(filters.to_date)}
          onChange={(e) => onFilterChange("to_date", toUTCISOString(e.target.value))}
        />
      </div>

      <div style={{ display: "flex", gap: "8px", alignItems: "flex-end" }}>
        <Button onClick={onReset} variant="secondary" style={{ height: "30px" }}>
          Reset Filters
        </Button>
      </div>
    </div>
  );
};
export default FilterSection;
